import { clsx } from 'clsx';
import type React from 'react';

export interface AvatarProps {
    src?: string | null;
    square?: boolean;
    initials?: string;
    alt?: string;
    className?: string;
    textColor?: string;
}

const Avatar = ({
    src = null,
    square = false,
    initials,
    alt = '',
    className,
    textColor,
    ...props
}: AvatarProps & React.ComponentPropsWithoutRef<'span'>) => {
    return (
        <span
            data-slot="avatar"
            {...props}
            className={clsx(
                className,
                // Basic layout
                'inline-grid shrink-0 align-middle [--avatar-radius:20%] *:col-start-1 *:row-start-1',
                // Border radius
                square ? 'rounded-(--avatar-radius) *:rounded-(--avatar-radius)' : 'rounded-full *:rounded-full'
            )}
        >
            {initials && (
                <svg
                    className={clsx(
                        'size-full p-[5%] text-[48px] font-semibold uppercase select-none',
                        textColor ? textColor : 'fill-teal-500'
                    )}
                    viewBox="0 0 100 100"
                    aria-hidden={alt ? undefined : 'true'}
                >
                    {alt && <title>{alt}</title>}
                    <text
                        x="50%"
                        y="50%"
                        alignmentBaseline="middle"
                        dominantBaseline="middle"
                        textAnchor="middle"
                        dy=".125em"
                    >
                        {initials}
                    </text>
                </svg>
            )}
            {src && <img className="size-full" src={src} alt={alt} />}
        </span>
    );
};

export default Avatar;
